import React, { FunctionComponent } from "react";
import Loader from "react-loader-spinner";
import { DARK_COLOR } from "../../constants/colors";

interface CenteredLoaderProps {
  color?: string;
}

const CenteredLoader: FunctionComponent<CenteredLoaderProps> = ({ color }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "calc(50%)",
        left: "calc(50% - 50px)"
      }}
    >
      <Loader
        color={color || DARK_COLOR}
        type="Triangle"
        height={100}
        width={100}
      />
    </div>
  );
};
export default CenteredLoader;
